import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';
import client from '../api/client';

const KEY = 'ywf_cookie_notice';

const visitorId = () => {
  let id = localStorage.getItem('ywf_visitor_id');
  if (!id) {
    id = (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
    localStorage.setItem('ywf_visitor_id', id);
  }
  return id;
};

export const CookieBanner = () => {
  const [show, setShow] = useState(false);
  useEffect(() => { if (!localStorage.getItem(KEY)) setShow(true); }, []);
  if (!show) return null;

  const choose = (choice) => {
    localStorage.setItem(KEY, JSON.stringify({ choice, at: new Date().toISOString() }));
    setShow(false);
    client.post('/legal/cookie-consent', { choice, visitor_id: visitorId(), page_url: window.location.pathname }).catch(() => {});
  };

  return (
    <div data-testid="cookie-banner" className="fixed bottom-4 left-4 right-4 sm:right-auto sm:max-w-md z-[60] rounded-2xl bg-[#2A1F1B] text-[#F4E4DA] p-5 shadow-2xl border border-[#5A4439] animate-float-up">
      <div className="flex items-start gap-3">
        <Cookie className="w-5 h-5 text-[#F4D6CE] flex-shrink-0 mt-0.5" />
        <div className="space-y-3">
          <p className="text-sm leading-relaxed">
            We only use essential cookies needed to sign you in and keep the site working. No advertising or cross-site tracking cookies.{' '}
            <Link to="/cookies" className="underline text-[#F4D6CE]">Cookie notice</Link>
          </p>
          <div className="flex gap-2 flex-wrap">
            <button data-testid="cookie-banner-ok" onClick={() => choose('acknowledged')} className="text-xs px-4 py-2 rounded-full bg-[#F4D6CE] text-[#2A1F1B] font-medium hover:bg-white transition-colors">Got it</button>
            <button data-testid="cookie-banner-essential" onClick={() => choose('essential_only')} className="text-xs px-4 py-2 rounded-full border border-[#8E7B70] hover:border-[#F4D6CE] transition-colors">Essential only</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
